import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LanguageSelector from '../../../components/ui/LanguageSelector';
import { translateStaticText } from '../../../config/staticAssessmentTranslations';

const sections = [
  { icon: '🔢', name: 'Quantitative & Logical', exclusive: false },
  { icon: '🧠', name: 'Cognitive Battery', exclusive: false },
  { icon: '💼', name: 'Skill & Technical', exclusive: false },
  { icon: '📝', name: 'Verbal & Communication', exclusive: false },
  { icon: '📊', name: 'Data & Abstract Reasoning', exclusive: false },
  { icon: '💻', name: 'Coding Fundamentals', exclusive: true },
  { icon: '🎯', name: 'Situational Judgement', exclusive: true }
];

export default function IntroPage() {
  const navigate = useNavigate();
  const [visibleCount, setVisibleCount] = useState(0);
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleCount((prev) => {
        if (prev >= sections.length) {
          clearInterval(interval);
          return prev;
        }
        return prev + 1;
      });
    }, 350);

    return () => clearInterval(interval);
  }, []);

  const ready = visibleCount >= sections.length;
  const displaySections = sections.map((section) => ({
    ...section,
    name: translateStaticText(section.name, currentLanguage),
    questionCountLabel: translateStaticText('10 questions', currentLanguage),
    exclusiveLabel: translateStaticText('EXCLUSIVE', currentLanguage)
  }));

  return (
    <div className="min-h-screen mega-intro-bg px-4 py-12 flex items-center justify-center">
      <div className="w-full max-w-4xl text-center">
        <div className="flex justify-end mb-4">
          <LanguageSelector
            currentLanguage={currentLanguage}
            onLanguageChange={setCurrentLanguage}
            isTranslating={false}
          />
        </div>
        <h1 className="font-cabinet text-4xl md:text-5xl text-white mega-shimmer-text">{translateStaticText('Apex All-in-One Mega Bundle', currentLanguage)}</h1>
        <p className="mt-3 text-white/75">{translateStaticText('7 Sections · 70 Questions · ~75 minutes · Fully Proctored', currentLanguage)}</p>

        <div className="mt-10 grid gap-3 max-w-3xl mx-auto">
          {displaySections.map((section, index) => {
            const active = visibleCount > index;
            return (
              <div
                key={`${index}_${section.icon}`}
                className={`mega-intro-item rounded-xl border border-white/20 bg-white/10 backdrop-blur-xl px-4 py-4 text-left flex items-center justify-between ${active ? 'is-visible' : ''} ${section.exclusive ? 'mega-exclusive-item' : ''} transition-opacity duration-200`}
                style={{ animationDelay: `${0.35 * index}s` }}
              >
                <div className="flex items-center gap-3 text-white">
                  <span className="text-xl" aria-hidden="true">{section.icon}</span>
                  <span className="font-medium">{section.name}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm text-white/60">{section.questionCountLabel}</span>
                  {section.exclusive ? <span className="text-[10px] px-2 py-0.5 rounded-full bg-yellow-300 text-slate-900 font-semibold">{section.exclusiveLabel}</span> : null}
                </div>
              </div>
            );
          })}
        </div>

        {ready ? (
          <>
            <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-yellow-200/40 bg-yellow-200/15 px-4 py-2 text-sm text-yellow-100">
              <span className="h-6 w-6 rounded-full border border-yellow-100/50 inline-flex items-center justify-center">✓</span>
              {translateStaticText('7/7 sections loaded', currentLanguage)}
            </div>
            <div>
              <button
                type="button"
                onClick={() => navigate('/assessment/mega/test')}
                className="mt-6 rounded-xl bg-gradient-to-r from-yellow-400 via-amber-500 to-orange-600 px-8 py-3 text-slate-900 font-semibold shadow-lg shadow-amber-500/45 mega-begin-btn"
              >
                {translateStaticText('Begin Apex Assessment →', currentLanguage)}
              </button>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}
